import React, { Component, Fragment } from 'react'
import noop from 'lodash/noop'
import cn from 'classnames'

import { getReducedNumber } from 'client/shared/helpers/text-helpers'
import Linka from 'client/shared/blocks/linka'
import { Trans } from '@lingui/react'

import { NavItem } from 'client/bookmate/helpers/nav-helper'

import './sub-header-nav.styl'

type Props = {
  nav: NavItem[]
  showAuthPopup?: () => void
  onLinkClick: (link: string) => void
  includeSubpaths?: boolean
  isLoggedIn: boolean
}

export class SubHeaderNav extends Component<Props> {
  static defaultProps = {
    onLinkClick: noop,
  }

  render(): JSX.Element {
    const { nav, onLinkClick, includeSubpaths } = this.props

    return (
      <div className="sub-header-nav">
        <div className="sub-header-nav__overflow">
          <div className="sub-header-nav__inner">
            {nav.map((navLink, i) => {
              const count = navLink.count ? getReducedNumber(navLink.count) : 0
              const counterEl = (
                <Fragment>
                  <span className="sub-header-nav__count">{count}</span>
                  <span>
                    <Trans id={navLink.message} values={{ count }} />
                  </span>
                </Fragment>
              )

              if (navLink.count <= 0) {
                return (
                  <div className="sub-header-nav__item" key={i}>
                    {counterEl}
                  </div>
                )
              }

              return (
                <Linka
                  path={navLink.path}
                  activeClassName="sub-header-nav__link_active"
                  className={cn('sub-header-nav__link', {
                    'sub-header-nav__link_has-updated-series':
                      navLink.hasUpdatedSeries,
                  })}
                  includeSubpaths={includeSubpaths}
                  key={i}
                  pseudo={navLink.pseudoLink}
                  onClick={event => {
                    if (!navLink.bypassAuth) {
                      event.preventDefault()

                      onLinkClick(navLink.path)
                    }
                  }}
                >
                  {counterEl}
                </Linka>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}
